const dashBoardPrefix = 'DASHBOARD';
const sportBettingPrefix = 'SPORTS_BETTING';
// prematch *************
const sbPrematch = `${sportBettingPrefix}.PREMATCH`;
const sbPrematchBulkActions = `${sbPrematch}.BULK_ACTIONS`;
const sbPrematchRead = `${sbPrematch}.READ`;
const sbPrematchUpdate = `${sbPrematch}.UPDATE`;
const sbPrematchCreate = `${sbPrematch}.CREATE`;
const sbPrematchParsers = `${sbPrematch}.PARSERS`;
const sbPrematchExternal = `${sbPrematch}.EXTERNAL`;
const sbPrematchPairing = `${sbPrematch}.PAIRING`;
const sbPrematchPairingRead = `${sbPrematchPairing}.READ`;
const sbPrematchResults = `${sbPrematch}.RESULTS`;
const sbPrematchResultsCreate = `${sbPrematchResults}.CREATE`;
const sbPrematchResultsUpdate = `${sbPrematchResults}.UPDATE`;
const sbPrematchResultsRead = `${sbPrematchResults}.READ`;
const sbPrematchResultsDelete = `${sbPrematchResults}.DELETE`;
const sbPrematchResultsConfirm = `${sbPrematchResults}.CONFIRM`;
const sbPrematchActions = `${sbPrematch}.ACTIONS`;
const sbPreActionsDetails = `${sbPrematchActions}.DETAILS`;
const sbPreDetailsSwapTeams = `${sbPreActionsDetails}.SWAP_TEAMS`;
const sbPreBlockEvent = `${sbPreActionsDetails}.BLOCK_EVENT`;
const sbPreBlockFeed = `${sbPreActionsDetails}.BLOCK_FEED`;
const sbPreResultReset = `${sbPreActionsDetails}.RESULT_RESET`;
const sbPreProcessorConfig = `${sbPreActionsDetails}.PROCESSOR_CONFIG`;
const sbPreChangeStartTime = `${sbPreActionsDetails}.CHANGE_EVENT_START_TIME`;
const sbPreStatus = `${sbPreActionsDetails}.CHANGE_EVENT_STATUS`;
const sbPreConfirm = `${sbPreActionsDetails}.CONFIRM`;
const sbPreBetRestrictionConfig = `${sbPreActionsDetails}.BET_RESTRICTION_CONFIG`;
const sbPreActionsQuotas = `${sbPrematchActions}.QUOTAS`;
const sbPreActionsResultHistory = `${sbPrematchActions}.RESULT_HISTORY`;
const sbPreActionsSwapTeams = `${sbPrematchActions}.SWAP_TEAMS`;
const sbPreActionsProcessor = `${sbPrematchActions}.PROCESSOR`;
const sbParticipants = `${sportBettingPrefix}.PARTICIPANTS`;
// bets **************
const sbBets = `${sportBettingPrefix}.BETS`;
const sbBetsRead = `${sbBets}.READ`;
const sbBetsUpdate = `${sbBets}.UPDATE`;
const sbBetsDelete = `${sbBets}.DELETE`;
const sbBetsCreate = `${sbBets}.CREATE`;
// live **************
const sbLive = `${sportBettingPrefix}.LIVE`;
const sbLiveConfirm = `${sbLive}.CONFIRM`;
const sbLiveQuotasOn = `${sbLive}.QUOTAS_ON`;
const sbLiveQuotasOf = `${sbLive}.QUOTAS_OFF`;
const sbLiveActions = `${sbLive}.ACTIONS`;
const sbLiveActionsDetails = `${sbLiveActions}.DETAILS`;
const sbLiveDetailsSwapTeams = `${sbLiveActionsDetails}.SWAP_TEAMS`;
const sbLiveBlockEvent = `${sbLiveActionsDetails}.BLOCK_EVENT`;
const sbLiveBlockFeed = `${sbLiveActionsDetails}.BLOCK_FEED`;
const sbLiveResultReset = `${sbLiveActionsDetails}.RESULT_RESET`;
const sbLiveProcessorConfig = `${sbLiveActionsDetails}.PROCESSOR_CONFIG`;
const sbLiveChangeStartTime = `${sbLiveActionsDetails}.CHANGE_START_TIME`;
const sbLiveStatus = `${sbLiveActionsDetails}.STATUS`;
const sbLiveDetailsConfirm = `${sbPreActionsDetails}.CONFIRM`;
const sbLiveBetRestrictionConfig = `${sbLiveActionsDetails}.BET_RESTRICTION_CONFIG`;
const sbLiveQuotas = `${sbLiveActions}.QUOTAS`;
const sbLiveActionsResultHistory = `${sbLiveActions}.RESULT_HISTORY`;
const sbLiveActionsSwapTeams = `${sbLiveActions}.SWAP_TEAMS`;
const sbLiveActionsProcessor = `${sbLiveActions}.PROCESSOR`;
const sbLiveExternal = `${sbLive}.EXTERNAL`;
const sbLiveExternalStart = `${sbLiveExternal}.START`;
// import ***********************************
const sbImport = `${sportBettingPrefix}.IMPORT`;
const sbImportPublishRevision = `${sbImport}.PUBLISH_REVISION`;
const sbBetRestrictions = `${sportBettingPrefix}.BET_RESTRICTIONS`;
const sbBetRestrictionsUpdate = `${sbBetRestrictions}.UPDATE`;
const sbBetRestrictionsCreate = `${sbBetRestrictions}.CREATE`;
const sbBetRestrictionsDelete = `${sbBetRestrictions}.DELETE`;
const sbBetRestrictionsRead = `${sbBetRestrictions}.READ`;
const sbEventsStatistics = `${sportBettingPrefix}.EVENTS_STATISTICS`;
const sbCompetitionData = `${sportBettingPrefix}.COMPETITION_DATA`;
// risk *******************************
const riskPrefix = 'RISK';
const riskVerification = `${riskPrefix}.VERIFICATION`;
const riskSettings = `${riskPrefix}.SETTINGS`;
const riskSettingsRead = `${riskSettings}.READ`;
const riskSettingsUpdate = `${riskSettings}.UPDATE`;
const riskSettingsCreate = `${riskSettings}.CREATE`;
const riskSettingsDelete = `${riskSettings}.DELETE`;
// e-commerce *******************************
const ecommercePrefix = 'ECOMMERCE';
const ecommerceBank = `${ecommercePrefix}.BANK`;
const ecommerceTobacco = `${ecommercePrefix}.TOBACCO`;
const ecommerceSkrill = `${ecommercePrefix}.SKRILL`;
// quota management *********************************
const quotaMgtPrefix = 'QUOTA_MGT';
const quotaMgtPairing = `${quotaMgtPrefix}.PAIRING`;
const quotaMgtQuotas = `${quotaMgtPrefix}.QUOTAS`;
// devtools  *********************************
const devToolsPrefix = 'DEV_TOOLS';
const devToolsTicketMonitor = `${devToolsPrefix}.TICKET_MONITOR`;
const devToolsAccessLog = `${devToolsPrefix}.ACCESS_LOG`;
const devToolsNodes = `${devToolsPrefix}.NODES`;
const devToolsClients = `${devToolsPrefix}.CLIENTS`;
const devToolsI18N = `${devToolsPrefix}.I18N`;
const devToolsSystem = `${devToolsPrefix}.SYSTEM`;
// system ********************************
const systemCacheCleaner = `${devToolsSystem}.CACHE.READ`;
const systemRevisions = `${devToolsSystem}.REVISION.READ`;
const systemAppReload = `${devToolsSystem}.APP_RELOAD.READ`;

// maintenance ****************************
const maintenance = `${devToolsPrefix}.MAINTENANCE`;
const maintenanceRead = `${maintenance}.READ`;
const maintenanceAdd = `${maintenance}.ADD`;
const maintenanceUpdate = `${maintenance}.UPDATE`;
// users  *********************************
const usersPrefix = 'USERS';
const usersRead = `${usersPrefix}.READ`;
const usersCreate = `${usersPrefix}.CREATE`;
const userChangeAlias = `${usersPrefix}.CHANGE_ALIAS`;
const userCards = `${usersPrefix}.CARDS`;
const userCardsMembership = `${userCards}.MEMBERSHIP`;
const userCardsPredefined = `${userCards}.PREDEFINED`;
const userCardsVouchers = `${userCards}.VOUCHERS`;
const userChangeUmcn = `${usersPrefix}.CHANGE_UMCN`;
const userChangeEmail = `${usersPrefix}.CHANGE_EMAIL`;
const userRiskConfig = `${usersPrefix}.RISK_CONFIG`;
// business  *********************************
const businessPrefix = 'BUSINESS';
const businessCasinoClientSummary = `${businessPrefix}.CASINO_CLIENT_SUMMARY`;
const businessCasinoUsersSummary = `${businessPrefix}.CASINO_USERS_SUMMARY`;
const businessCasinoUsersTransactions = `${businessPrefix}.CASINO_USERS_TRANSACTIONS`;
const businessWebTransactions = `${businessPrefix}.WEB_TRANSACTIONS`;
const businessWebTransactionsSummary = `${businessPrefix}.WEB_TRANSACTIONS_SUMMARY`;
const businessWebTransactionsUpdate = `${businessWebTransactions}.UPDATE`;
const businessShopTransactionsSummary = `${businessPrefix}.SHOP_TRANSACTIONS_SUMMARY`;
const businessAtmTransactionsSummary = `${businessPrefix}.ATM_TRANSACTIONS_SUMMARY`;
const businessLucky6TransactionsSummary = `${businessPrefix}.LUCKY6_TRANSACTIONS_SUMMARY`;
const businessAtmBalance = `${businessPrefix}.ATM_BALANCE`;
// tickets ******************************
const ticketsPrefix = 'TICKETS';
const ticketsSportBetting = `${ticketsPrefix}.SPORT_BETTING.READ`;
const ticketsLucky6 = `${ticketsPrefix}.LUCKY6`;
const ticketOperatorsFilter = `${ticketsPrefix}.OPERATORS_FILTER.READ`;
// Agent System *************************
const agentSystem = 'AGENT_SYSTEM';
const agentSystemUsersRead = `${agentSystem}.READ`;
const agentSystemUsersCreate = `${agentSystem}.CREATE`;
const agentSystemUsersUpdate = `${agentSystem}.UPDATE`;
const agentSystemMoneyTransfer = `${agentSystem}.MONEY_TRANSFER`;
const agentSystemMoneyTransferPayIn = `${agentSystem}.MONEY_TRANSFER.PAY_IN`;
const agentSystemMoneyTransferPayOut = `${agentSystem}.MONEY_TRANSFER.PAY_OUT`;
const agentSystemTicketsRead = `${agentSystem}.TICKETS.READ`;
const agentSystemTicketsStatusUpdate = `${agentSystem}.TICKETS.STATUS_UPDATE`;
const agentSystemBalance = `${agentSystem}.BALANCE`;

// UUI *************************
const uisPrefix = 'UIS';
const uisRead = `${uisPrefix}.READ`;
const uisCreate = `${uisPrefix}.CREATE`;
const uisUpdate = `${uisPrefix}.UPDATE`;
const uisDelete = `${uisPrefix}.DELETE`;

// tehnical support
const technicalSupport = 'TECHNICAL_SUPPORT.READ';

// processing
const processing = 'PROCESSING.READ';

// atm's and shops
const atmShops = 'ATM_SHOPS.READ';

export const userClaims = {
  sportBettingPrefix,
  sbPrematch,
  sbPrematchBulkActions,
  sbPrematchCreate,
  sbPrematchUpdate,
  sbPrematchRead,
  sbPrematchParsers,
  sbPrematchExternal,
  sbPrematchPairing,
  sbPrematchPairingRead,
  sbPrematchResults,
  sbPrematchResultsUpdate,
  sbPrematchResultsCreate,
  sbPrematchResultsDelete,
  sbPrematchResultsRead,
  sbPrematchResultsConfirm,
  sbPreActionsDetails,
  sbPreDetailsSwapTeams,
  sbPreBlockEvent,
  sbPreBlockFeed,
  sbPreResultReset,
  sbPreProcessorConfig,
  sbPreChangeStartTime,
  sbPreStatus,
  sbPreConfirm,
  sbPreBetRestrictionConfig,
  sbPreActionsQuotas,
  sbPreActionsResultHistory,
  sbPreActionsSwapTeams,
  sbPreActionsProcessor,
  sbBets,
  sbBetsRead,
  sbBetsCreate,
  sbBetsDelete,
  sbBetsUpdate,
  sbLive,
  sbLiveConfirm,
  sbLiveQuotasOn,
  sbLiveQuotasOf,
  sbLiveActions,
  sbLiveActionsDetails,
  sbLiveDetailsSwapTeams,
  sbLiveBlockEvent,
  sbLiveBlockFeed,
  sbLiveResultReset,
  sbLiveProcessorConfig,
  sbLiveChangeStartTime,
  sbLiveStatus,
  sbLiveDetailsConfirm,
  sbLiveBetRestrictionConfig,
  sbLiveActionsSwapTeams,
  sbLiveActionsResultHistory,
  sbLiveQuotas,
  sbLiveActionsProcessor,
  sbLiveExternal,
  sbLiveExternalStart,
  sbImport,
  sbImportPublishRevision,
  sbBetRestrictions,
  sbBetRestrictionsCreate,
  sbBetRestrictionsDelete,
  sbBetRestrictionsRead,
  sbBetRestrictionsUpdate,
  sbEventsStatistics,
  sbCompetitionData,
  sbParticipants,
  riskPrefix,
  riskSettings,
  riskSettingsRead,
  riskSettingsCreate,
  riskSettingsUpdate,
  riskSettingsDelete,
  riskVerification,
  ecommercePrefix,
  ecommerceBank,
  ecommerceTobacco,
  ecommerceSkrill,
  quotaMgtPrefix,
  quotaMgtPairing,
  quotaMgtQuotas,
  devToolsPrefix,
  devToolsTicketMonitor,
  devToolsAccessLog,
  devToolsNodes,
  devToolsClients,
  devToolsI18N,
  devToolsSystem,
  usersPrefix,
  usersRead,
  usersCreate,
  userChangeAlias,
  userChangeUmcn,
  userChangeEmail,
  userRiskConfig,
  userCards,
  userCardsMembership,
  userCardsPredefined,
  userCardsVouchers,
  businessPrefix,
  businessCasinoClientSummary,
  businessCasinoUsersSummary,
  businessCasinoUsersTransactions,
  businessWebTransactions,
  businessWebTransactionsUpdate,
  businessWebTransactionsSummary,
  businessShopTransactionsSummary,
  businessAtmTransactionsSummary,
  businessLucky6TransactionsSummary,
  businessAtmBalance,
  dashBoardPrefix,
  ticketsSportBetting,
  ticketsLucky6,
  ticketOperatorsFilter,
  systemCacheCleaner,
  systemRevisions,
  systemAppReload,
  maintenance,
  maintenanceRead,
  maintenanceAdd,
  maintenanceUpdate,
  agentSystem,
  agentSystemUsersRead,
  agentSystemUsersCreate,
  agentSystemUsersUpdate,
  agentSystemMoneyTransfer,
  agentSystemMoneyTransferPayIn,
  agentSystemMoneyTransferPayOut,
  agentSystemTicketsRead,
  agentSystemTicketsStatusUpdate,
  agentSystemBalance,
  uisPrefix,
  uisRead,
  uisCreate,
  uisUpdate,
  uisDelete,
  technicalSupport,
  processing,
  atmShops,
};






